import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg, useApi } from "@/lib/api";

const num = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

export function WalletLimits({ tid, limits, active, onSaved }) {
  const api = useApi();
  const [m, setM] = useState(limits?.monthly_cap_credits ?? "");
  const [o, setO] = useState(limits?.per_op_cap_credits ?? "");
  const save = () => api.put(`/t/${tid}/wallet/limits`, { monthly_cap_credits: num(m), per_op_cap_credits: num(o) })
    .then(() => { toast.success("Limiti salvati"); onSaved(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-4" data-testid="wallet-limits">
      <p className="text-sm font-medium text-slate-800">Limiti contro spese impreviste</p>
      <p className="text-[11px] text-slate-500">Vuoto = nessun limite. Oltre il limite l'operazione non parte. Ogni azione mostra i crediti prima della conferma.{!active && " Il wallet si attiva con il piano o la prima ricarica."}</p>
      <div className="mt-2 flex flex-wrap items-end gap-2">
        <label className="text-xs text-slate-600">Al mese (crediti)<Input className="h-9 w-32" type="number" min={0} value={m} onChange={(e) => setM(e.target.value)} data-testid="wallet-limit-month" /></label>
        <label className="text-xs text-slate-600">Per operazione (crediti)<Input className="h-9 w-32" type="number" min={1} value={o} onChange={(e) => setO(e.target.value)} data-testid="wallet-limit-op" /></label>
        <Button size="sm" onClick={save} data-testid="wallet-limits-save">Salva limiti</Button>
      </div>
    </section>);
}
